import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../utils/helper";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";

export const reportactionApiService = createApi({
  reducerPath: "reportactionApi",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["ReportAction"],
  endpoints: (builder) => ({
    getReportAction: builder.query({
      query: ({ id, params = {} }) => {
        const query = queryParams(params);
        if (id) return `reportaction/get/${id}${query}`;
        return `reportaction/get${query}`;
      },
      keepUnusedDataFor: 0,
      providesTags: (result, error, { id }) => [{ type: "ReportAction", id }],
    }),
    // body: { status: "resolved" | "remove" | "stopposting", removereason, removeperiod }
    updateReportAction: builder.mutation({
      query: ({ id, body, params = {} }) => {
        const query = queryParams(params);
        return {
          url: `reportaction/${id}${query}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, error, { id }) => [
        { type: "ReportAction", id },
      ],
    }),
  }),
});

export const { useGetReportActionQuery, useUpdateReportActionMutation } =
  reportactionApiService;
